import ReactMarkdown from "react-markdown";

/**
 * Styled markdown renderer for legal documents pulled from /api/legal/current.
 * Kept in a component so the same look applies across the Terms page, the
 * Privacy page, and the LegalConsentModal.
 */
export default function LegalMarkdown({ body, className = "" }) {
  return (
    <div
      data-testid="legal-markdown"
      className={`legal-markdown font-body text-text-primary ${className}`}
    >
      <ReactMarkdown
        components={{
          h1: ({ node, ...props }) => (
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-text-primary leading-tight mb-4" {...props} />
          ),
          h2: ({ node, ...props }) => (
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-text-primary mt-10 mb-4" {...props} />
          ),
          h3: ({ node, ...props }) => (
            <h3 className="text-xl font-heading font-semibold text-text-primary mt-6 mb-3" {...props} />
          ),
          p: ({ node, ...props }) => (
            <p className="text-base leading-relaxed mb-4" {...props} />
          ),
          ul: ({ node, ...props }) => (
            <ul className="list-disc list-outside ml-6 space-y-2 mb-4 text-base leading-relaxed" {...props} />
          ),
          ol: ({ node, ...props }) => (
            <ol className="list-decimal list-outside ml-6 space-y-2 mb-4 text-base leading-relaxed" {...props} />
          ),
          li: ({ node, ...props }) => <li className="pl-1" {...props} />,
          strong: ({ node, ...props }) => (
            <strong className="font-bold text-text-primary" {...props} />
          ),
          code: ({ node, ...props }) => (
            <code className="px-1.5 py-0.5 rounded bg-[#F1F5F9] text-primary-dark text-sm font-mono" {...props} />
          ),
          a: ({ node, ...props }) => (
            <a className="text-primary underline hover:text-primary-dark" {...props} />
          ),
        }}
      >
        {body || ""}
      </ReactMarkdown>
    </div>
  );
}
